// extracted by mini-css-extract-plugin
export default {"header":"Navbar_header__3etKv","firsticons":"Navbar_firsticons__iaXTD","grandparent":"Navbar_grandparent__6xEo4"};